import request from '../utils/request'

/**
 * 创建企业
 */
export function createCompany(data) {
  return request({
    url: '/admin/company',
    method: 'post',
    data
  })
}

/**
 * 更新企业
 */
export function updateCompany(data) {
  return request({
    url: '/admin/company',
    method: 'put',
    data
  })
}

/**
 * 删除企业
 */
export function deleteCompany(id) {
  return request({
    url: `/admin/company/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取企业详情
 */
export function getCompanyById(id) {
  return request({
    url: `/admin/company/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询企业列表
 */
export function getCompanyList(params) {
  return request({
    url: '/admin/company/list',
    method: 'get',
    params
  })
}

/**
 * 获取所有企业列表（不分页）
 */
export function getAllCompanies() {
  return request({
    url: '/admin/company/all',
    method: 'get'
  })
}

/**
 * 更新企业配额
 */
export function updateCompanyQuota(companyId, data) {
  return request({
    url: `/admin/company/${companyId}/quota`,
    method: 'put',
    data
  })
}

/**
 * 获取企业配额信息
 */
export function getCompanyQuota(companyId) {
  return request({
    url: `/admin/company/${companyId}/quota`,
    method: 'get'
  })
}

